import { MutationOptions } from "@apollo/client";

import Button, { ButtonProps } from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";
import useTriggerScan, { ScanForTrigger } from "shared/Scan/useTriggerScan";

type TriggerScanButtonProps = {
  scan: ScanForTrigger;
  refetchQueries?: MutationOptions["refetchQueries"];
  variant?: ButtonProps["variant"];
};

const TriggerScanButton = ({
  scan,
  refetchQueries,
  variant = "primary",
}: TriggerScanButtonProps) => {
  const { canTrigger, isTriggering, isTriggerDisabled, trigger } = useTriggerScan({
    scan,
    refetchQueries,
  });

  return (
    <Tooltip
      active={!!canTrigger.message}
      on={(tooltipProps) => (
        <Button
          {...tooltipProps}
          variant={variant}
          loading={isTriggering}
          disabled={isTriggerDisabled}
          onPress={trigger}
        >
          Trigger scan
        </Button>
      )}
    >
      {canTrigger.message}
    </Tooltip>
  );
};

export default TriggerScanButton;
